export const WebUiPaymentCardModalEnI18n = {
    title: 'Card Details',
    actions: {
        add: 'Add Card',
    },
};
